import { useDynamicSvgImport } from '@/hooks/useDynamicSvgImport'

type DynamicSVGImportProps = {
  name: string
} & React.SVGProps<SVGSVGElement>

export default function DynamicSVGImport(props: DynamicSVGImportProps) {
  const { name, ...rest } = props

  const { error, loading, SvgIcon } = useDynamicSvgImport(name)

  if (error) return <div>{error.message}</div>

  if (loading) return <div>loading...</div>

  if (SvgIcon) {
    return <SvgIcon {...rest} />
  }

  return null
}
